import CurrencyConversion from '../../Functions/Currency'
export default {
  methods: {
    removeInventory: function (key) {
      var localInventory = JSON.parse(localStorage.getItem('activity_data'))
      localInventory.splice(key, 1)
      this.$store.commit('CHOSEN_ACTIVITIES', localInventory)
      // this.$store.commit('REMOVE_INVENTORY', inventory)
      localStorage.setItem('activity_data', JSON.stringify(localInventory))
    },
    removeDonation: function (key) {
      var localDonation = JSON.parse(localStorage.getItem('donation'))
      localDonation.splice(key, 1)
      this.$store.commit('PUBLIC_DONATION', localDonation)
      localStorage.setItem('donation', JSON.stringify(localDonation))
    },
    removeOnlineDonation: function (key) {
      var localDonation = this.$store.state.DonationStore.online_donation
      localDonation.splice(key,1)
      this.$store.commit('ONLINE_PAYMENT_DONATION', localDonation)
    },
    activityDifference: function (activity) {
      return this.findActivityTotal(activity) - this.activityDiscount(activity) - this.activityCommission(activity)
    },
    activityDiscount: function (activity) {
      if (activity.discount_status === 'true') {
        var discounts = activity.discounts
        var discount = 0
        var activityD = 0
        for (var i = 0; i < discounts.length; i++) {
          if (this.gate_pass.tour_operator.type_public_id === discounts[i].discount_type_id) {
            discount = discounts[i].discount
          }
        }
        activityD = this.findActivityTotal(activity) * Number(discount) / 100
        return activityD
      } else {
        return 0
      }
    },
    activityCommission: function (activity) {
      if (activity.discount_status === 'true') {
        var discounts = activity.discounts
        var discount = 0
        var activityD = 0
        for (var i = 0; i < discounts.length; i++) {
          if (this.gate_pass.tour_operator.type_public_id === discounts[i].discount_type_id) {
            discount = discounts[i].commission
          }
        }
        activityD = this.findActivityTotal(activity) * Number(discount) / 100
        return activityD
      } else {
        return 0
      }
    },
    findActivityTotal: function (activity) {
      // Extra children validation
      if (activity.extra_pax_children < 0 || activity.extra_pax_children === '') {
        activity.extra_pax_children = 0
      }
      // Extra adults validation
      if (activity.extra_pax_adults < 0 || activity.extra_pax_adults === '') {
        activity.extra_pax_adults = 0
      }
      // Discount validation
      if (activity.activity_discount === '') {
        activity.activity_discount = 0
      }
      var total = 0
      var discount = Number(activity.activity_discount) / 100
      var children = Number(activity.children) + Number(activity.extra_pax_children)
      // var childPrice = Number(activity.child_price)
      var childPrice = Number(Math.round(this.convert1(activity.currency, activity.child_price).amount))
      var adults = Number(activity.adults) + Number(activity.extra_pax_adults)
      // var adultPrice = Number(activity.adult_price)
      var adultPrice = Number(Math.round(this.convert1(activity.currency, activity.adult_price).amount))
      var childCost = children * childPrice
      var adultCost = adults * adultPrice
      total = childCost + adultCost
      total = total - (discount * total)
      // Converting the child and adult costs before doing the total calculations to bring it in line with
      // how calculations are done by the booking service
      // total = this.convert1(activity.currency, total).amount
      // total = this.$roundOff(total)
      return total
    },
    findMemberActivityDiscount: function (activity, discount) {
      if (discount === undefined) {
        discount = 0
      }
      let total = this.findActivityTotal(activity)
      total = total - (Number(discount) / 100 * total)
      return total
    },
    findMemberAccommodationDiscount: function (accommodation, discount) {
      if (discount === undefined) {
        discount = 0
      }
      let total = this.facilityTotal(accommodation)
      total = total - (Number(discount) / 100 * total)
      return total
    },
    findMemberEntryDiscount: function (activity, discount) {
      let total = this.findActivityTotal(activity)
      total = total - (Number(discount) / 100 * total)
      return total
    },
    findOldActivityTotal: function (activity) {
      var total = 0
      total = activity.inventory_booking_total_cost
      return total
    }
  },
  computed: {
    allInventoryTotal: function () {
      var total = 0
      for (var x = 0; x < this.chosenInventory.length; x++) {
        total = total + this.findActivityTotal(this.chosenInventory[x])
      }
      return total
    },
    inventorySchedule: function () {
      return this.$store.state.BookingStore.inventory_schedule
    },
    inventorySurge: function () {
      return this.$store.state.ActivityStore.surge_schedule
    },
    chosenInventory: function () {
      return this.$store.state.ActivityStore.chosenInventory
    },
    bookedInventory: function () {
      return this.$store.state.ActivityStore.bookedInventory
    },
    inventoryImages: function () {
      return this.$store.state.ActivityStore.activity_images
    },
    allInventory: function () {
      return this.$store.state.ActivityStore.active_facilities
    },
    activeInventory: function () {
      return this.$store.state.ActivityStore.active_activities
    },
    inventoryWithPrices: function () {
      var array = []
    
      this.activeInventory.map(function (inventory) {
        if (inventory.pricing_status === 'true') {
          array.push(inventory)
        }
      })
      return array
    },
    selectedInventory: function () {
      return this.$store.state.ActivityStore.inventory_selection
    },
    inActiveInventory: function () {
      return this.$store.state.ActivityStore.in_active_activities
    },
    singlePricing: function () {
      return this.$store.state.ActivityPricingStore.activity_pricing
    },
    singleInventory: function () {
      return this.$store.state.ActivityStore.activity
    },
    activitySlots: function () {
      return this.$store.state.BookingStore.activity_slots
    },
    inventoryPriceSchedule: function () {
      return this.$store.state.ActivityPricingStore.activity_pricings
    },
    inventoryAvailabilitySchedule: function () {
      return this.$store.state.ActivityStore.availability_schedule
    },
    inventoryBudget: function () {
      return this.$store.state.ActivityPricingStore.inventory_selection
    },
    inventoryAvailability: function () {
      return this.$store.state.ActivityStore.inventory_num
    },
    inventoryContact: function () {
      return this.$store.state.ActivityContactStore.activity_contacts
    },
    inventoryCurrency: function () {
      return this.$store.state.ActivityCurrencyStore.all_activity_currencies
    },
    updateInventory: function () {
      if (this.$route.name === 'EditInventory') {
        this.inventory.code = this.singleInventory.code
        this.inventory.analysis_code = this.singleInventory.analysis_code
        this.inventory.vat = this.singleInventory.vat
        this.inventory.categing_levy = this.singleInventory.categing_levy
        this.inventory.sub_code = this.singleInventory.sub_code
        this.inventory.google_analytics_code = this.singleInventory.google_analytics_code
        this.inventory.facebook_tag = this.singleInventory.facebook_tag
        this.inventory.name = this.singleInventory.name
        this.inventory.description = this.singleInventory.description
        this.inventory.maximum_guests = this.singleInventory.maximum_guests
        this.inventory.minimum_guests = this.singleInventory.minimum_guests;
        this.inventory.ranger_marker = this.singleInventory.ranger_marker
        this.inventory.has_extras = this.singleInventory.has_extras
        this.inventory.lead_time_format = this.singleInventory.lead_time_format;
        this.inventory.lead_time = this.singleInventory.lead_time;
      }
    }
  },
  mixins: [CurrencyConversion]
}
